import { render, staticRenderFns } from "./Deal.vue?vue&type=template&id=ed8892ac&scoped=true"
import script from "./Deal.vue?vue&type=script&lang=js"
export * from "./Deal.vue?vue&type=script&lang=js"
import style0 from "./Deal.vue?vue&type=style&index=0&id=ed8892ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8892ac",
  null
  
)

export default component.exports